import React from "react";
import { useFormContext } from "react-hook-form";

const InputXs = (props) => {
    const {register} = useFormContext()
    return (
        <input 
            {...props}
            {...register(props.name)}
            className={"p-0 font-medium leading-none text-lavender placeholder:text-lavender-30 border-x-transparent border-t-transparent border-b-lavender focus:border-x-transparent focus:border-t-transparent " + props.className || ''}  
        />
    )
}

export default InputXs